import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { Tooltip } from 'reactstrap'
import { UpdateTaskMutation } from "../Mutations"
import { TaskStatusOptionsQuery } from '../Queries'
import toTitleCase from "../../Functions/toTitleCase"
import "./Components.css"

//  define async function to update task columns that can be used in other components

export const updateTask = async ({ taskId, input, client }) => {
    try {
        // const { client } = props
        if (!client) {
            throw new Error("GQL Client not found")
        }
        if (!taskId) {
            throw new Error("Task ID is required")
        }
        const newInput = {
            taskId: taskId,
            ...input
        }

        const result = await client.mutate({
            mutation: UpdateTaskMutation,
            variables: { input: newInput },
            update: (cache, { data }) => {
                const updatedTask = data?.updateTask?.task
                if (!updatedTask) return
                cache.modify({
                    id: cache.identify(updatedTask),
                    fields: {
                        status: () => updatedTask.status,
                        dueDate: () => updatedTask.dueDate,
                    },
                })
            },
        })
        if (!result) {
            throw new Error("Error updating task")
        }
        if (result.data && result.data.updateTask && result.data.updateTask.ok) {
            return true
        } else {
            const errorMessage = result.data && result.data.updateTask && result.data.updateTask.errors && result.data.updateTask.errors.messages ? result.data.updateTask.errors.messages[0] : "Unknown Error"
            throw new Error(errorMessage)
        }
    }
    catch (error) {
        console.log("Error updating task", error)
        throw new Error(error)
    }
}

export default function StatusDropDown({ taskId, taskStatus, isAutomated, client, closeModal }) {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const { data: taskStatusData } = useQuery(TaskStatusOptionsQuery)

    if (!taskId || !taskStatus) return null

    const getStatusClass = (status) => {
        if (status === "OPEN") return "status-open"
        if (status === "IN_PROGRESS") return "status-inprogress"
        if (status === "INCOMPLETE") return "status-incomplete"
        if (status === "CANCELED") return "status-canceled"
        if (status === "DONE") return "status-done"
        return ""
    }

    const statuses = taskStatusData?.optionsList?.enumValues?.map((status) => {
        return {
            key: status.name,
            label: status.description || toTitleCase(status.name),
            className: getStatusClass(status.name),
        }
    }) || [
            { key: "OPEN", label: "OPEN", className: "status-open" },
            { key: "IN_PROGRESS", label: "IN PROGRESS", className: "status-inprogress" },
            { key: "INCOMPLETE", label: "INCOMPLETE", className: "status-incomplete" },
            { key: "DONE", label: "DONE", className: "status-done" },
        ]

    const selectableStatuses = isAutomated
        ? statuses.filter(({ key }) => !["DONE", "CANCELED"].includes(key))
        : statuses

    const updateTaskStatus = async (status) => {
        try {
            if (!status || loading) return
            setLoading(true)
            const result = await updateTask({ taskId, input: { status }, client })
            if (result) setError("")
            if (typeof closeModal === "function") {
                closeModal("")
            }
        } catch (err) {
            setError("Error updating task: " + err.toString())
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="Components status-selector">
            {error && <div className="text-danger status-selector-error">{error}</div>}
            <div className="status-selector-list">
                {selectableStatuses.map(({ key, label, className }) => {
                    return (
                        <button key={key} type="button" disabled={loading} onClick={() => updateTaskStatus(key)} className={`status-selector-option ${className} ${taskStatus === key ? "active-status" : ""}`}>
                            <span className="status-selector-icon-wrap" aria-hidden="true">
                                {taskStatus === key ? <i className="fa fa-check status-selector-check" /> : <span className="status-selector-dot" />}
                            </span>
                            <span className="status-selector-label">{toTitleCase(label)}</span>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}

export function TooltipComponent({ tooltipOpen, toggle, target, message, ...args }) {
    return (
        <div>
            <Tooltip {...args} isOpen={tooltipOpen} target={target} toggle={toggle}>
                {message}
            </Tooltip>
        </div>
    )
}
